<template>
  <div class="home">
    <div
      style="display: flex; justify-content: center; width: 100%"
      id="toolbar"
    ></div>
    <div id="editor"></div>
  </div>
</template>

<script>
// @ is an alias to /src

import InlineEditor from "@ckeditor/ckeditor5-build-inline";
import "@ckeditor/ckeditor5-build-inline/build/translations/zh-cn.js";
import { GetOs, GetCurrentBrowser } from "@/utils/index";
import AMapLoader from "@amap/amap-jsapi-loader";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import axios from "axios";
window._AMapSecurityConfig = {
  securityJsCode: "03f8e7a407744636ad58958472b185d1",
};
export default {
  name: "HomeView",
  data() {
    return {
      base_url: "https://www.haikan.xyz/DdkSamrtQRCodeSystemApi/",
      // base_url: 'http://192.168.0.206:8900',
      editor: null,
      data: "",
      query: {
        equipType: "",
        clientType: "",
        area: "",
        user: "",
        cyQrCodeId: "",
      },
    };
  },
  mounted() {
    console.log(location.href);
    let uri = location.href.split("?")[1];
    this.query.cyQrCodeId = uri.split("=")[1];
    this.query.equipType = GetOs();
    this.query.clientType = GetCurrentBrowser();
    this.getId();
    AMapLoader.load({
      key: "c7ea0d5585616fb771f25c1f470c2040", // 申请好的Web端开发者Key，首次调用 load 时必填
      version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: [
        "AMap.ToolBar",
        "AMap.PolygonEditor",
        "AMap.MouseTool",
        "AMap.RangingTool",
        "AMap.PlaceSearch",
      ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    }).then((AMap) => {
      AMap.plugin("AMap.CitySearch", () => {
        var citySearch = new AMap.CitySearch();
        citySearch.getLocalCity((status, result) => {
          if (status === "complete" && result.info === "OK") {
            this.query.area = result.province;
            // 查询成功，result即为当前所在城市信息
          } else {
            this.query.area = "未知";
          }

          setTimeout(() => {
            this.init();
          }, 500);
        });
      });
    });
  },
  methods: {
    async getId() {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      console.log(result);
      this.query.user = result.visitorId;
    },
    init() {
      axios({
        url: this.base_url + "/qrcode/qrCode/get",
        method: "get",
        params: this.query,
      }).then((res) => {
        // console.log(res);
        let data = res.data.data.qrData ? res.data.data.qrData : "";
        // console.log(data);
        InlineEditor.create(document.querySelector("#editor"), {
          language: "zh-cn",
        })
          .then((editor) => {
            this.editor = editor;
            const toolbarContainer = document.querySelector("#toolbar");
            toolbarContainer.appendChild(editor.ui.view.toolbar.element);

            editor.enableReadOnlyMode("editorReadOnly");
            // 去掉内容框边框
            const Element = editor.ui.view.editable.element;
            Element.style.border = "none";
            // 隐藏工具栏
            const toolbarElement = editor.ui.view.toolbar.element;
            toolbarElement.style.display = "none";
            editor.setData(data.replace(/\\/g, ""));
            this.onBind();

            // 清除音频默认样式
            let spanAudio = document.querySelectorAll(
              `.ddkAudio-box .box span`
            );
            let Audio = document.querySelectorAll(
                `.ddkAudio-box .box span audio`
            );
            // if(Audio[0]){
            //   Audio[0].play()
            // }
            for (let i = 0; i < spanAudio.length; i++) {
              spanAudio[i].removeAttribute("data-html-object-embed-label");
              spanAudio[i].removeAttribute("class");
            }
            let ele = document.createElement('div')
            ele.addEventListener('click',()=>{
              Audio[0].play()
            })
            ele.click()
            ele.remove()

            // 清除视频默认样式
            let spanVideo = document.querySelectorAll(
              `.ddkVideo-box .box span`
            );
            let video = document.querySelectorAll(`.ddkVideo-box video`);
            console.log(spanVideo);
            for (let i = 0; i < spanVideo.length; i++) {
              spanVideo[i].removeAttribute("data-html-object-embed-label");
              spanVideo[i].removeAttribute("class");
              video[i].removeAttribute("class");
            }
          })
          .catch((error) => {
            console.error(
              "There was a problem initializing the editor.",
              error
            );
          });
      });
    },
    onBind() {
      let ele = document.querySelectorAll(".ddkFile-box .item");
      console.log(ele);
      for (let i = 0; i < ele.length; i++) {
        ele[i].addEventListener("click", (e) => {
          console.log(ele[i].getAttribute("fileurl"));
          window.open(ele[i].getAttribute("fileurl"));
        });
      }
    },
  },
  beforeDestroy() {
    this.editor.ui.view.toolbar.element.innerHTML = null;
    this.editor.destroy();
    this.editor = null;
  },
};
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  padding-top: 28px;
}

#editor {
  width: 100%;
  box-sizing: border-box;
}

::v-deep .ddkFile-box {
  // overflow-y: auto;
  border: 1px solid #e7e7e7;
  padding: 0 16px;
  border-radius: 5px;
  .item {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding: 14px 0;
    width: 100%;
    background: #fcfcfc;
    border-radius: 5px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e7e7e7;
    &:last-child {
      border: none;
    }
    .left {
      display: flex;
      align-items: center;
      .img {
        width: 45px;
        height: 48px;
        pointer-events: none;
        img {
          width: 45px;
          height: 48px;
        }
      }
      .text {
        margin-left: 12px;
        .name {
          // width: 400px;
          line-height: 24px;
          font-size: 15px;
          font-weight: 400;
          color: #343434;
          word-break: break-all;
        }
        .size {
          line-height: 20px;
          font-size: 13px;
          font-weight: 400;
          color: #9a9a9a;
        }
      }
    }
  }
}

::v-deep .ddkVideo-box {
  .item {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 14px;
    background: #fcfcfc;
    border: 1px solid #e7e7e7;
    border-radius: 5px;

    .cons {
      width: 100%;
      pointer-events: none;
      .box {
        pointer-events: none;
      }
    }

    video {
      width: 100%;
      // height: 30px;
      pointer-events: auto;
    }

    .text {
      display: flex;
      justify-content: space-between;
      padding: 2px;
      box-sizing: border-box;
    }
  }
}

::v-deep .ddkAudio-box {
  .item {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 14px;
    background: #fcfcfc;
    border: 1px solid #e7e7e7;
    border-radius: 5px;

    .cons {
      width: 100%;
      .box {
        pointer-events: none;
      }
    }

    audio {
      width: 100%;
      height: 30px;
      pointer-events: auto;
    }

    .text {
      display: flex;
      justify-content: space-between;
      padding: 2px;
      box-sizing: border-box;
    }
  }
}
</style>
